import * as React from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'

interface CenteredTabsProps {
  value: string
  handleChange: (event: React.SyntheticEvent, newValue: string) => void
  isGrantDateValid: boolean | '' | undefined | null
}

export default function CenteredTabs({
  value,
  handleChange,
  isGrantDateValid,
}: CenteredTabsProps) {
  return (
    <Tabs
      value={value}
      onChange={handleChange}
      sx={{
        marginBottom: 2,
        '& .MuiTabs-indicator': {
          backgroundColor: '#9135E0', // Purple indicator
        },
        '& .MuiTabs-flexContainer': {
          display: 'flex',       
          gap: '14px',          
        },
        '& .MuiTab-root': {
          // Default tab style
          color: '#6B7280',
          fontSize: {xs: '15px', sm: '20px'},
          fontWeight: 500,
          padding: '12px 12px',
          fontFamily: 'InterMedium',
          '&.Mui-selected': {
            // Selected tab style
            color: '#9135E0', // Purple text for selected tab
            fontWeight: 500,
          },
        },
      }}>
      <Tab label="Removal Stats" value={'Removal Stats'} />
      {isGrantDateValid && (
        <Tab 
        label="Opt Out Requests" 
        value={'Opt Out Requests'} 
        className="opt-out-requests-tab"  
        />
      )}
    </Tabs>
  )
}
